import * as Backend from '@/core/backend'

export async function loadStorageMaps (params) {
  const res = await Backend.callApi({
    apiName: 'StorageMap.LoadMaps',
    inputData: {
      FacilityNo: params
    }
  })
  if (!res.failed && res.data !== null) {
    // Sort so newest is top-most
    res.data = res.data.sort((a, b) =>
      (a.CreatedData < b.CreatedData) ? 1 : ((b.CreatedData < a.CreatedData) ? -1 : 0))
  }
  return res
}

export async function loadStaticStorageMaps (params) {
  const res = await Backend.callApi({
    apiName: 'StorageMap.LoadStaticMaps',
    inputData: {
      FacilityNo: params.facilityNo,
      CorpName: params.corpName
    }
  })
  if (!res.failed && res.data !== null) {
    // Sort so newest is top-most
    res.data = res.data.sort((a, b) =>
      (a.CreatedData < b.CreatedData) ? 1 : ((b.CreatedData < a.CreatedData) ? -1 : 0))
  }
  return res
}

export async function loadFacilityData (params) {
  const res = await Backend.callApi({
    apiName: 'StorageMap.LoadFacilityData',
    inputData: {
      FacilityNo: params.facilityNo,
      CorpName: params.corpName
    }
  })
  return res
}

export async function loadFacilityDataUser (params) {
  const res = await Backend.callApi({
    apiName: 'StorageMap.LoadFacilityDataUser',
    inputData: {
      FacilityNo: params.facilityNo,
      CorpName: params.corpName
    }
  })
  return res
}

export async function loadStorageRegs (params) {
  const res = await Backend.callApi({
    apiName: 'StorageMap.LoadRegsForStorage',
    inputData: {
      StorageId: params
    }
  })
  if (!res.failed && res.data !== null) {
    // Sort so newest is top-most
    /* res.data = res.data.sort((a, b) =>
      (a.CreatedData < b.CreatedData) ? 1 : ((b.CreatedData < a.CreatedData) ? -1 : 0)) */
  }
  return res
}

export async function saveStorageMaps (params) {
  const res = await Backend.callApi({
    apiName: 'StorageMap.SaveStorageLocation',
    inputData: {
      storageLocation: params
    }
  })
  return res
}

export async function loadFacility (facilityNo, corpId) {
  const res = await Backend.callApi({
    apiName: 'StorageMap.LoadFacility',
    inputData: {
      facilityNo: facilityNo,
      corpId: corpId
    }
  })
  return res
}
